module.exports = __webpack_public_path__ + "ui-static/img/hooks-filter-default_light.f480b193.svg";